module.exports = __webpack_public_path__ + "img/2.5a9bb9d6.png";